import React, { useMemo } from "react";
import { Center, Image, Text, Box } from "@chakra-ui/react";

type Props = {
  src: string;
  author: string;
};

const FeedImage = ({ src, author }: Props) => {
  const imageSrc = useMemo(() => {
    if (!/^https?:\/\//.test(src)) return "https://" + src;
    return src;
  }, [src]);

  return (
    <>
      <Center>
        <Image src={imageSrc} alt={"Feed image"} maxH={300} />
      </Center>
      <Box mt={3}>{author ? <Text fontSize="sm"> - {author}</Text> : null}</Box>
    </>
  );
};

export default FeedImage;
